<template>
  <div class="container">
    <dv-border-box-7 class="message"> 无法直接访问，请通过后台打开驾驶舱 </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "page_404",
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #fff;
  font-size: 60px;
}

.message{
    width: 80%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: 180px;
}
</style>
